import { useForm } from "react-hook-form";
import LabelInput from "../../../../../shared/components/labelInput";
import NewDateTimePicker from "../../../../../shared/components/newDateTimePicker";
import SpOtherMapper from "../mappers/spOtherMapper";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import SupportNavigationButtons from "../../../components/support/SupportNavigationButtons";
import { handleSupportNext } from "../../../utils/supportNavUtils";
import { useNavigate } from "react-router-dom";
import FieldStack from "../../../../../shared/components/FieldStack";
import QuoteStepHeading from "../../../../../shared/components/QuoteStepHeading";

const SpOther = () => {
  const {
    register,
    watch,
    setValue,
    control,
    trigger,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({
    defaultValues: SpOtherMapper.get(),
    mode: "onChange",
  });

  const navigate = useNavigate();

  const onSubmit = (data) => {
    SpOtherMapper.set(data);
    handleSupportNext(navigate);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <QuoteFormWrapper>
        <QuoteStepHeading title="Other" className="tw-mb-6" />
        <FieldStack className="tw-w-full">
        <LabelInput
          id="otherDetails"
          label="Please provide details of the change"
          type="textarea"
          placeholder="Enter details"
          register={register("otherDetails", {
            required: "Comments are required",
          })}
          errors={errors.otherDetails}
          watch={watch("otherDetails")}
          trigger={trigger}
          maxLength={500}
        />

        <NewDateTimePicker
          name="otherEffectiveDateTime"
          label="Effective Date and Time"
          errors={errors.otherEffectiveDateTime}
          setValue={setValue}
          control={control}
          rules={{ required: "Date is required" }}
          watch={watch}
          defaultValue={watch("otherEffectiveDateTime")}
          minDate={new Date()}
          trigger={trigger}
        />
        </FieldStack>
      </QuoteFormWrapper>
      <SupportNavigationButtons isValid={isValid} />
    </form>
  );
};

export default SpOther;
